import * as React from 'react';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import ProfileForm from '../../containers/ProfileForm';
import i18n from '../../resources/i18n';
/**
 * ユーザ情報画面
 * @param props
 */
const Profile: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('Profile_0001')} />
			<ProfileForm />
		</>
	);
};

export default Profile;



// WEBPACK FOOTER //
// ./src/pages/personal/Profile.tsx